import { ogImage } from "./media";

const DESC_FALLBACK = "Powered by Sh0p";

/** Host only: domain or `{username}.sh0p.in`. */
export function storeHost(store) {
  if (!store) return "";
  if (store.domain) {
    return String(store.domain).replace(/^https?:\/\//, "").replace(/\/$/, "");
  }
  if (store.username) return `${store.username}.sh0p.in`;
  return "";
}

export function storeBaseUrl(store) {
  const host = storeHost(store);
  return host ? `https://${host}` : "";
}

/** Store base + path (no query/hash). Home → `https://host` (no trailing slash). */
export function storePageUrl(store, path = "/") {
  const base = storeBaseUrl(store);
  if (!base) return "";
  const raw = typeof path === "string" && path ? path : "/";
  const pathOnly = raw.split("?")[0].split("#")[0];
  const normalized = pathOnly.startsWith("/") ? pathOnly : `/${pathOnly}`;
  if (normalized === "/") return base;
  return `${base}${normalized}`;
}

export function storeMetaTitle(store) {
  if (store?.name) return store.name;
  return storeHost(store);
}

export function storeMetaDescription(store) {
  if (store?.about) return store.about;
  return DESC_FALLBACK;
}

export function storeLogoUrl(store) {
  if (!store?.logo) return null;
  const src = typeof store.logo === "string" ? store.logo : store.logo.src;
  const media = typeof store.logo === "object" ? store.logo : null;
  const url = ogImage(src, media);
  return url || null;
}

export function buildStorefrontMeta(store, path = "/") {
  const title = storeMetaTitle(store);
  const description = storeMetaDescription(store);
  const pageUrl = storePageUrl(store, path);
  const image = storeLogoUrl(store);

  return { title, description, pageUrl, image };
}
